export const formatCurrency = (value,currency) => {
  const checkedValue = !isNaN(parseFloat(value)) ? parseFloat(value) : 0;
  const intl = new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: currency === 'dollard' ? 'USD' : 'EUR',
    currencyDisplay:'narrowSymbol',
  });
  return intl.format(checkedValue);
};
